import { render, staticRenderFns } from "./CloseConfirm.vue?vue&type=template&id=4671222a"
import script from "./CloseConfirm.vue?vue&type=script&lang=js"
export * from "./CloseConfirm.vue?vue&type=script&lang=js"
import style0 from "./CloseConfirm.vue?vue&type=style&index=0&id=4671222a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports